import { render, staticRenderFns } from "./CartProductTable.vue?vue&type=template&id=2d25ca69"
import script from "./CartProductTable.vue?vue&type=script&lang=js"
export * from "./CartProductTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports